import { Link } from 'react-router-dom';
import SectionTitle from '@/components/base/SectionTitle';
import { articles, categories } from '@/mocks/incidents';

export default function LatestReports() {
  const sorted = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);

  return (
    <section className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <SectionTitle
          label="时间线"
          title="最新通报与进展"
          desc="按时间倒序整理公开来源的通报、抓捕与解救信息，帮助读者快速掌握近期动态。"
        />

        <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-8">
            <ol className="relative border-l border-background-200 pl-6">
              {sorted.map((item) => (
                <li key={item.id} className="relative pb-7 last:pb-0">
                  <span className="absolute -left-[29px] top-1 flex h-3 w-3 items-center justify-center">
                    <span className="h-3 w-3 rounded-full border-2 border-background-50 bg-primary-500"></span>
                  </span>
                  <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-foreground-500">
                    <time className="font-medium text-foreground-800">{item.date}</time>
                    <span className="rounded-sm bg-secondary-100 px-2 py-0.5 font-medium text-secondary-800">
                      {item.category}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-map-pin-line"></i>
                      {item.region}
                    </span>
                  </div>
                  <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                    <Link to={`/cases/${item.id}`} className="transition-colors hover:text-primary-700">
                      {item.title}
                    </Link>
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                </li>
              ))}
            </ol>
          </div>

          <aside className="flex flex-col gap-6 lg:col-span-4">
            <div className="rounded-xl border border-background-200 bg-background-50 p-5 md:p-6">
              <h3 className="font-heading text-sm font-semibold text-foreground-950">主题分类</h3>
              <ul className="mt-4 space-y-1">
                {categories.map((cat) => (
                  <li key={cat.key}>
                    <Link
                      to={`/cases?category=${encodeURIComponent(cat.key)}`}
                      className="group flex items-center gap-3 rounded-md px-3 py-2.5 transition-colors hover:bg-background-100"
                    >
                      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background-100 text-primary-600">
                        <i className={`${cat.icon} text-base`}></i>
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block text-sm font-medium text-foreground-900 group-hover:text-primary-700">
                          {cat.key}
                        </span>
                        <span className="line-clamp-1 block text-[11px] text-foreground-500">{cat.desc}</span>
                      </span>
                      <i className="ri-arrow-right-s-line text-foreground-400"></i>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-xl border border-accent-200 bg-accent-50 p-5 md:p-6">
              <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-accent-900">
                <i className="ri-alert-line"></i>
                重要提示
              </h3>
              <p className="mt-3 text-xs leading-relaxed text-accent-900">
                如家人疑似被困境外，请先整理姓名、证件信息、最后联系时间与聊天记录，再通过官方渠道反映。
                切勿轻信所谓「交钱放人」，避免造成二次损失。
              </p>
              <Link
                to="/about#contact"
                className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-accent-800 transition-colors hover:text-accent-900"
              >
                前往线索提供
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}